<template>
    <b-card no-body class="mb-4" id="analytics">
        <template v-slot:header>
            <h5 class="mb-0">
                {{ $t("basic_analytics") }}
            </h5>
        </template>
        <b-card-body v-if="!loading">
            <div class="calendar-plugin">
                <calendar
                    @date-changed="handleDateChangedTrigger"
                    :controls="[
                        { title: 'Year', type: 2 },
                        { title: 'Month', type: 3 },
                        { title: 'Week', type: 4 },
                        { title: 'Day', type: 5 },
                    ]"
                >
                </calendar>
            </div>

            <h5>
                {{ $t("issues_encountered") }}
            </h5>
            <fail-category-container
                :base_product="product.id"
                :product_variant="variantId"
            ></fail-category-container>
            <hr class="my-5" />
            <h5>
                {{ $t("product_export_log") }}
            </h5>
            <monthly-exports-container
                :base_product="product.id"
                :product_variant="variantId"
                :show-controls="false"
            >
            </monthly-exports-container>
        </b-card-body>
    </b-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import FailCategoryContainer from "../../Analytics/FailCategoryContainer";
import MonthlyExportsContainer from "../../Analytics/MonthlyExportsContainer";
import Calendar from "../../Analytics/Calendar/Calendar";

export default {
  name: "SmartvaultAnalytics",
  components: { MonthlyExportsContainer, FailCategoryContainer, Calendar },
  data() {
    return {
      start_date: null,
      end_date: null,
      unit: null
    };
  },
  computed: {
    ...mapState("smartVaultProduct", {
      product: state => state.product,
      loading: state => state.loading
    }),
    ...mapGetters("smartVaultProduct", {
      variant: "getVariant"
    }),
    variantId() {
      return this.variant ? this.variant.id : null;
    }
  },
  methods: {
    handleDateChangedTrigger(event) {
      this.currentRangeName = event.rangeTitle;

      this.$store.commit("analytics/setDates", {
        start_date: event.startDate,
        end_date: event.endDate,
        unit: event.unit
      });

      this.$root.$emit("failCat");
      this.$root.$emit("montlyExp");
    }
  }
};
</script>

<style scoped>
.calendar-plugin {
  margin-bottom: 10px;
}
</style>
